export const EmptyErrorStack = '[empty onerror]';
